import { Hero } from "app/components/hero";
import { Stack, Button, Icon, Flex, UnorderedList, ListItem } from "@chakra-ui/react";
import banner from "public/gns3-hosted-services/banner.webp";
import Link from "next/link";
import { GNS3_FEATURES_LIST } from "./constants";
import { GoArrowRight } from "@onemind-services-llc/react-icons-ng/go";

const HeroSection = () => {
  return (
    <Hero
      title="Network Simulation Like Never Before with GNS3 Hosted Service"
      image={banner}
      description={[
        "Discover Flexibility with GNS3: Our month-to-month subscription service adapts to your project timeline, ensuring you have the lab resources exactly when you need them.",
        "What you get with CloudMyLab: ",
      ]}
    >
      <UnorderedList spacing={1} mb={0}>
        {GNS3_FEATURES_LIST.map((point, index) => (
          <ListItem key={index} fontSize={{ base: "md", lg: "lg" }} color={"gray.800"}>
            {point}
          </ListItem>
        ))}
      </UnorderedList>
      <Stack direction={{ base: "column", md: "row" }} spacing={6}>
        <Button
          bg={"#007FFF"}
          borderColor="#007FFF"
          borderWidth={"1px"}
          color={"white"}
          fontSize={"lg"}
          _hover={{ backgroundColor: "#0056B3" }}
          as={"a"}
          href={"#contact-form"}
          minW={"180px"}
          minH={"45px"}
        >
          Schedule A Demo
        </Button>
        <Flex
          alignItems={"center"}
          _hover={{ textDecoration: "underline" }}
          justifyContent={"center"}
        >
          <Link
            href={"#section-pricing"}
            style={{
              color: "#007FFF",
              fontSize: "20px",
              fontWeight: "600",
              paddingLeft: "6px",
              paddingRight: "6px",
              alignItems: "center",
            }}
          >
            View Pricing
            <Icon as={GoArrowRight} ml={2} style={{ verticalAlign: "middle" }} />
          </Link>
        </Flex>
      </Stack>
    </Hero>
  );
};

export default HeroSection;
